__turbopack_context__.v({
  "color-cycle": "LogoAnimation-module__U6-QeW__color-cycle",
  "colorCycle": "LogoAnimation-module__U6-QeW__colorCycle",
});
